<template>
  <div class="search">
    <div class="outer-section" v-if="!isLoading">
      <h1 class="mb-4 mt-5">Suchergebnisse Bücher</h1>

      <p v-if="books.length == 18">
        Es werden nur <strong>{{books.length}}</strong> Treffer angezeigt,
        grenzen Sie Ihre Suche weiter ein.
      </p>
      <p v-else>
        Ihre Suche ergab <strong>{{ books.length }}</strong> Treffer.
      </p>

      <div
        v-for="book in books"
        :key="book.slug">

        <b-card class="bookTile my-2" :img-src="book.previewImage" img-left>
          <b-card-title>
            <b-link :to="{name: 'book', params: { slug: book.slug }}">{{book.title}}</b-link>
          </b-card-title>

          <b-card-text>
            {{book.subtitle}}
          </b-card-text>
        </b-card>
      </div>

      <h1 class="mb-4 mt-5">Suchergebnisse Artikel</h1>

      <p v-if="articles.length == 18">
        Es werden nur <strong>{{articles.length}}</strong> Treffer angezeigt,
        grenzen Sie Ihre Suche weiter ein.
      </p>
      <p v-else>
        Ihre Suche ergab <strong>{{ articles.length }}</strong> Treffer.
      </p>

      <div
        v-for="article in articles"
        :key="article.slug">
          <RwvArticleTile
            :article="article">
          </RwvArticleTile>
      </div>
    </div>

    <div class="text-center my-2" v-else>
      <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RwvArticleTile from "@/components/Articles/ArticleTile";
import store from "@/store";
import { SEARCH_BOOKS, SEARCH_ARTICLES } from "@/store/actions.type";

export default {
  title () {
    return `Seite durchsuchen | So wird's gemacht`
  },
  components: {
    RwvArticleTile
  },
  data () {
    return {
      isLoadingBooks: true,
      isLoadingArticles: true,
      books: [],
      articles: [],
    }
  },
  computed: {
    ...mapGetters([
      "defaultParamsArticles",
      "defaultParamsBooks",
      "searchText"
      ]),
    isLoading() {
      return this.isLoadingBooks || this.isLoadingArticles
    },

  },
  mounted() {
    this.loadBooks()
    this.loadArticles()
  },
  watch: {
    searchText() {
    this.loadBooks()
    this.loadArticles()
    }
  },
  methods: {
    loadBooks() {
      var me = this
      var booksParams = JSON.parse(JSON.stringify(me.defaultParamsBooks))
      booksParams.where = {
        "$text": { "search": this.searchText }
      }

      me.$store.dispatch(SEARCH_BOOKS, booksParams).then(function(data) {
        console.log("then in search")
        console.log(data)
        me.books = data
        me.isLoadingBooks = false
      }).catch(function(error) {
        me.isLoadingBooks = false

        console.log("booksParams")
        console.log(booksParams)
        console.log("error in search books")
        console.log(error)
      });
    },
    loadArticles() {
      var me = this
      var articleParams = JSON.parse(JSON.stringify(me.defaultParamsArticles))
      articleParams.where = {
        '$text': { search: this.searchText }
      }

      me.$store.dispatch(SEARCH_ARTICLES, articleParams).then(function(data) {
        console.log("then in search")
        console.log(data)
        me.articles = data
        me.isLoadingArticles = false
      }).catch(function(error) {
        me.isLoadingArticles = false

        console.log("articleParams")
        console.log(articleParams)
        console.log("error in search articles")
        console.log(error)
      });
    }
  }
}
</script>

<style lang="scss">
.bookTile {
  .card-img-left {
    max-width: 110px;
    max-height: 140px;
    width: 100%;
    height: 100%;
    margin: auto;
  }
}
</style>
